// extracted by mini-css-extract-plugin
export default {"row":"Income_row__sh0-J"};